import { UIManager } from "@/Imports"
import MultiplierManager from "@/managers/multipliers/MultiplierManager";
import AutoplayManager from "@/managers/autoplay/AutoplayManager";
import SoundsHandling from "@/managers/sound/SoundsHandling";
import BaseSoundManager from "@/managers/sound/BaseSoundManager";
import InactivityTimerManager from "@/managers/inactivityTimer/InactivityTimerManager";

export default class GameManager {

  constructor () {
    this.start()
  }

  start = () => {
    this.uiManager = new UIManager()
    this.multiplierManager = new MultiplierManager()
    this.autoplayManager = new AutoplayManager()
    this.inactivityTimerManager = new InactivityTimerManager()
  }
}